import * as React from 'react';

import Icon from '~/components/icon';
import { ServicesContext } from '~/providers/services-context';
import BettingActions from '~/services/actions/betting-actions';
import LocalStore from '~/services/actions/localstorage-actions';
import {
  TRACKING_ACTIONS,
  TRACKING_CATEGORIES,
  TRACKING_EVENTS } from
'~/services/actions/tracking-actions';
import {
  BETSLIP_OPEN,
  BETSLIPCOOKIE,
  CLIENT,
  CONFIGDATA,
  LABELS } from
'~/stores/constants';

import store, { withStoreSlices } from '../betslip.store';
import styles from '../style/mini-betslip.module.css';
import { comp } from '../util/utils';
import classNames from 'classnames';

type IBetslip = Record<string, IBetslipEntry>;

interface IBetslipEntry {
  betId: number;
  odds?: number;
  selectedBookie: string;
}

interface IMiniBetslipProps {
  betslipCookie?: string;
  betslipOpen?: boolean;
  labels?: Record<string, string>;
  className?: string;
}

interface IMiniBetslipState {
  betAdded: boolean;
  canRenderBetCount: boolean;
}

class MiniBetslip extends React.Component<
  IMiniBetslipProps,
  IMiniBetslipState>
{
  static contextType = ServicesContext;

  private betting: BettingActions;
  private localStore: LocalStore;

  private updateClient: (key: string, val: any) => void;

  constructor(props: IMiniBetslipProps) {
    super(props);

    // Services initialization
    this.betting = new BettingActions();
    this.localStore = new LocalStore();

    this.state = {
      betAdded: false,
      canRenderBetCount: false
    };

    this.updateClient = store.getState().updateClient;
  }

  public componentDidMount(): void {
    this.setState({ canRenderBetCount: true });
  }

  public shouldComponentUpdate(
  nextProps: IMiniBetslipProps,
  nextState: IMiniBetslipState)
  {
    return (
      nextState.canRenderBetCount !== this.state.canRenderBetCount ||
      nextProps.betslipCookie !== this.props.betslipCookie ||
      nextState.betAdded !== this.state.betAdded);

  }

  private handleBetslipToggle = () => {
    (
    this.context as React.ContextType<typeof ServicesContext>).
    trackingActions.eventTracking({
      event: TRACKING_EVENTS.BETSLIP_ICON_CLICKED,
      eventCategory: TRACKING_CATEGORIES.BETTING,
      eventAction: TRACKING_ACTIONS[TRACKING_EVENTS.BETSLIP_ICON_CLICKED]
    });

    const localStorageBetslip: IBetslip =
    this.localStore.select('intBetslip').getJSON() || {};
    const betslip: IBetslipEntry[] = Object.values(localStorageBetslip);

    this.betting.trackBetSlip(true, betslip);
    this.updateClient(BETSLIP_OPEN, !this.props.betslipOpen);
  };

  public componentDidUpdate(prevProps: IMiniBetslipProps) {
    if (prevProps.betslipCookie !== this.props.betslipCookie) {
      this.setState({
        betAdded: true
      });
    }

    if (this.state.betAdded) {
      setTimeout(() => {
        this.setState({
          betAdded: false
        });
      }, 400);
    }
  }

  private renderBetCount(): JSX.Element | null {
    const { canRenderBetCount } = this.state;
    if (!canRenderBetCount) return null;

    const betslipCookieArray = this.betting.getBetslipCookieArray();
    const betCount = betslipCookieArray.length;

    if (!betCount) {
      return null;
    }

    return (
      <span
        className={comp(
          styles.betCount,
          this.state.betAdded ? styles.betAdded : ''
        )}>

				{betCount}
			</span>);

  }

  public render(): JSX.Element {
    return (
      <div
        data-testid="betslip-button"
        className={styles.wrapper}
        onClick={this.handleBetslipToggle}>

				<div className={classNames(styles.miniBetslip, this.props.className)}>
					<Icon icon="Betslip" height={20} width={20} />
					{this.renderBetCount()}
				</div>
				<span className={styles.betslipText}>
					{this.props.labels?.['RESPONSIVE_BETSLIP']}
				</span>
			</div>);

  }
}

const MiniBetslipWithStoreSlices = withStoreSlices(MiniBetslip, {
  betslipOpen: [CLIENT, BETSLIP_OPEN],
  betslipCookie: [CLIENT, BETSLIPCOOKIE],
  labels: [CLIENT, CONFIGDATA, LABELS]
});
export default MiniBetslipWithStoreSlices;